// removed by extract-text-webpack-plugin
module.exports = {"White":"#FFFFFF","BreakpointToMedium":"(max-width: 639px)","shadowOpacityLow":"rgba(0,0,0,0.05)","wrapper":"G0be06f"};